import React from 'react';
import { Line } from '@ant-design/charts';
import { TimeSquare } from 'react-iconly';
const PURPLE = "#FFFF00";
const GREEN = "#85FB52";
const GREEN_LIGHT = "#57C592";
const RED = "#FF0000";
const BLUE = "#FFFF00";
const WHITE = "#fff";

function CustomLineChart () {
  const data = [
    { year: '1991', value: 15 },
    { year: '1992', value: 28 },
    { year: '1994', value: 22 },
    { year: '1995', value: 18},
    { year: '1996', value: 27 },
    { year: '1997', value: 23 },
    { year: '1998', value: 20 },
    { year: '1999', value: 8 },
  ];

  const config = {
    data,
    autoFit: false,
    xField: 'year',
    yField: 'value',
    yAxis: {
      minLimit: 0,
      maxLimit: 30,
      tickCount: 16,
      nice: true,
      line: { style: {fill: 'red', mode: "horizontal", stroke: '#aaa',value: 180,borderColor: GREEN, scaleID: "y-axis-0",
      borderWidth: 2,}},
    },
    annotation: {
      annotations: [
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: 180,
          borderColor: GREEN,
          borderWidth: 2,
          label: {
            backgroundColor: RED,
            //content: "Test Label",
            enabled: true
          }
        },
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: 180,
          borderColor: RED,
          borderWidth: 2,
          label: {
            backgroundColor: RED,
            //content: "Test Label",
            enabled: true
          }
        },
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: 80,
          borderColor: PURPLE,
          borderWidth: 1,
          label: {
            backgroundColor: RED,
            //content: "Test Label",
            enabled: true
          }
        },
        {
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          value: 120,
          borderColor: GREEN,
          borderWidth: 2,
          label: {
            backgroundColor: RED,
            //content: "Test Label",
            enabled: true
          }
        }
      ]
    },
    // annotations: [
     
    //   {
    //     type: 'regionFilter',
    //     start: ['min', 'median'],
    //     end: ['max', '0'],
    //     color: 'green',
    //   },
           
    //   {
    //     type: 'line',
    //     start: ['min', 'median'],
    //     end: ['max', 'median'],
    //     style: {
    //       stroke: '#F4664A',
    //       lineDash: [2, 2],
    //     },
    //   },
    //   {
    //     type: 'line',
    //     start: ['max', 'median'],
    //     end: ['max', '0'],
    //     style: {
    //       stroke: 'green',
    //       lineDash: [2, 2],
    //     },
    //   },     
    // ],
    color: ['#1979C9', '#D62A0D', '#33fa19'],
    xAxis: {
      grid: { line: { style: { stroke: '#eee' } } },
      line: { style: { stroke: '#aaa' } },
    },    
    point: {
      size: 3,
      shape: TimeSquare,
    },
    label: {
      style: {
        fill: '#aaa',
      },
    },
  };

  let chart;

  // Export Image
  const downloadImage = () => {
    chart?.downloadImage();
  };

  // Get chart base64 string
  const toDataURL = () => {
    console.log(chart?.toDataURL());
  };

  return (
    <div id='lineChart'
    //  style={{width:'100%',background:'#fff',padding:'15px',borderRadius:'20px'}}
    >
        <label style={{fontSize:'20px',fontWeight:'bolder',marginBottom:'10px'}}>Average Gloocose Summary</label>
              <Line {...config} onReady={(chartInstance) => (chart = chartInstance)} />
    </div>
  );
};
export default CustomLineChart;